/**
 * Module definition for endpoints module. The endpoints module manages
 * the application's top-level endpoints view (i.e., /endpoints).
 *
 * @module routes.endpoints
 */

angular.module('routes.endpoints', [
  'stack',
  'routes.endpoints.constants',
  'routes.endpoints.EndpointsController',
  'routes.endpoints.EndpointsPayloadResolver'
])
.config(
  [
    '$stateProvider',
    function ($stateProvider) {
      'use strict';

      $stateProvider
        .state('routes.endpoints', {
          url: '/endpoints/:endpoint/:id/:tab/:mode',
          templateUrl: 'routes/endpoints/endpoints.html',
          controller: 'EndpointsController',
          params: {
            endpoint: { value: null, squash: true },
            id: { value: null, squash: true },
            tab: { value: null, squash: true },
            mode: { value: null, squash: true }
          },
          resolve: {
            constants: [
              'ConstantResolver',
              'ENDPOINTS',
              function (ConstantResolver, ENDPOINTS) {
                return new ConstantResolver(ENDPOINTS);
              }
            ],
            endpointsPayload: [
              'EndpointsPayloadResolver',
              '$stateParams',
              'newmanPayload',
              function (EndpointsPayloadResolver, $stateParams, newmanPayload) {
                return new EndpointsPayloadResolver($stateParams, newmanPayload);
              }
            ]
          }
        }
      );
    }
  ]
);
